module.exports = __webpack_public_path__ + "img/selected2-min.95782656.png";